{
  "version": 1,
  "asset_id": "096dd7ef-1d98-49d4-b392-4bc26ec754c8",
  "project_id": "70779367-f3a9-4386-8ee3-6b59fdfe6940",
  "url": "/__l5e/assets-v1/096dd7ef-1d98-49d4-b392-4bc26ec754c8/hero-dscr-investment-property.jpg",
  "r2_key": "a/v1/70779367-f3a9-4386-8ee3-6b59fdfe6940/096dd7ef-1d98-49d4-b392-4bc26ec754c8/hero-dscr-investment-property.jpg",
  "original_filename": "hero-dscr-investment-property.jpg",
  "size": 395377,
  "content_type": "image/jpeg",
  "created_at": "2026-07-12T20:47:22Z"
}
